"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import SvgIcons from "./SvgIcons";

const Testimonials = () => {
  return (
    <div className="testi_con_all container mx-auto">

      <div className='flex justify-center items-center gap-4'>
        <SvgIcons.Lines className='w-[50px] md:w-[86px]' />
        <p
          className="bg-gradient-to-r w-fit text-center  from-[#1A5D6B] to-[#33B6D1] bg-clip-text text-transparent font-NeueMontrealBold text-[18px] md:text-4xl font-bold leading-normal"> Success Stories</p>
        <SvgIcons.Lines className='w-[50px] md:w-[86px]' />
      </div>

      <Swiper
        spaceBetween={30}
        slidesPerView={1}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        pagination={{ clickable: true }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="testimonial_swiper"
      >
        {[
          {
            text: "Cleanflow Systems has been a trusted partner for maintaining our cleanroom standards. Their equipment is of top quality, and their service is exceptional.",
            name: "Dr. Arvind Kumar",
            title: "Chief Medical Officer",
            hospital: "Apollo Hospitals",
          },
          {
            text: "We rely on Cleanflow Systems for critical cleanroom solutions. Their expertise and commitment to hygiene standards have been invaluable to our operations.",
            name: "Priya Menon",
            title: "Head of Infection Control",
            hospital: "Fortis",
          },
          {
            text: "Cleanflow Systems' equipment has played a crucial role in maintaining sterile conditions in our surgical and ICU environments. Highly recommended!",
            name: "Dr. Rajesh Iyer",
            title: "Senior Surgeon",
            hospital: "Global Hospitals",
          },
          {
            text: "Ensuring patient safety is our top priority, and Cleanflow Systems has helped us achieve the highest cleanliness standards in our facility.",
            name: "Anitha Reddy",
            title: "Director of Clinical Operations",
            hospital: "RELA INSTITUTE",
          },
          {
            text: "As a pediatric hospital, maintaining a sterile environment is crucial. Cleanflow Systems provides us with reliable and efficient cleanroom solutions.",
            name: "Dr. Vikram Sharma",
            title: "Pediatric Specialist",
            hospital: "Rainbow Children Hospital",
          },
          {
            text: "Cleanflow Systems' technology has significantly improved our infection control measures. Their products are a great asset to our hospital.",
            name: "Dr. Meera Krishnan",
            title: "Microbiology Consultant",
            hospital: "Apollo Hospitals",
          },
        ].map((testimonial, index) => (
          <SwiperSlide key={index} className="my-5 !overflow-visible">
            <div className="testimonial_con p-3">
              <p>"{testimonial.text}"</p>
              <p className=" !text-[14px]">{testimonial.name}, {testimonial.title}</p>
              <p className="!text-[#FB9A2A] !font-bold !text-[16px]">{testimonial.hospital}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export { Testimonials };
